import React from "react";
import "./index.css";
import { useDocTitle } from "../../components/CustomHook";

const Terms = () => {
  useDocTitle("Terms of Service | TLAppsHub");
  return (
    <div className="container">
      <p>
        This Terms of Service ("Agreement") is a legal contract between you and{" "}
        <strong>TLAppsHub</strong> concerning your use of our mobile
        applications ("Software") that you downloaded from app stores.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By downloading, installing, or using this Software, you agree to comply
        with the terms and conditions of this Agreement. If you do not agree,
        you are not permitted to use the Software.
      </p>

      <h2>2. Ownership</h2>
      <p>
        The Software and all related intellectual property rights, including but
        not limited to copyrights, trademarks, and trade secrets, are the
        property of TLAppsHub or our suppliers. You are not permitted to copy,
        modify, distribute, sell, or create derivative works from the Software.
      </p>

      <h2>3. Restrictions on Use</h2>
      <p>You are not permitted to:</p>
      <ul>
        <li>
          Disassemble, reverse engineer, or translate the Software into source
          code.
        </li>
        <li>Use the Software for illegal purposes.</li>
        <li>
          Use the Software on multiple devices unless expressly permitted by TLAppsHub.
        </li>
      </ul>

      <h2>4. Updates and Patches</h2>
      <p>
        TLAppsHub may provide updates, patches, or changes to the Software
        without prior notice. Updates are subject to this Agreement unless
        otherwise specified.
      </p>

      <h2>5. Disclaimer – Health, Medical & Wellness Features</h2>
      <p>
        Some features of the Software may allow you to log or track health
        information (e.g., heart rate estimation, blood pressure records, blood
        sugar logs, BMI calculation). These features are provided for{" "}
        <strong>general wellness and lifestyle purposes only</strong> and are{" "}
        <strong>not medical devices</strong>.
      </p>
      <p>
        The information provided by the Software is not intended to be medical
        advice, diagnosis, or treatment. Always seek the advice of a qualified
        healthcare professional with any questions about your health. Do not
        disregard or delay professional medical advice because of any
        information in the Software.
      </p>
      <p>
        We do not guarantee the accuracy or reliability of any health-related
        features. You assume full responsibility for your use of these features.
      </p>

      <h2>6. Disclaimer of Warranties</h2>
      <p>
        The Software is provided "as is" without any warranties, including but
        not limited to warranties of merchantability, fitness for a particular
        purpose, or non-infringement.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, TLAppsHub shall not be liable
        for any damages arising from the use or inability to use the Software,
        including errors in health features, data loss, or other damages, even
        if TLAppsHub has been advised of the possibility of such damages.
      </p>

      <h2>8. Termination</h2>
      <p>
        This Agreement remains in effect until terminated. TLAppsHub may
        terminate this Agreement at any time if you violate its terms. Upon
        termination, you must cease all use and uninstall the Software.
      </p>

      <h2>9. General Terms</h2>
      <p>
        If any provision of this Agreement is found invalid or unenforceable,
        that provision shall be modified or removed as necessary, and the
        remaining provisions shall continue in full force and effect.
      </p>

      <h2>10. Contact</h2>
      <p>
        If you have any questions regarding this Agreement, please contact us at{" "}
        <a href="mailto:tlappshub@gmail.com">tlappshub@gmail.com</a>.
      </p>

      <div className="footer">
        <p>
          <strong>TLAppsHub</strong>
        </p>
      </div>
    </div>
  );
};

export default Terms;
